import { render, staticRenderFns } from "./PhoneDetailModal.vue?vue&type=template&id=4befc438&scoped=true"
import script from "./PhoneDetailModal.vue?vue&type=script&lang=js"
export * from "./PhoneDetailModal.vue?vue&type=script&lang=js"
import style0 from "./PhoneDetailModal.vue?vue&type=style&index=0&id=4befc438&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4befc438",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4befc438')) {
      api.createRecord('4befc438', component.options)
    } else {
      api.reload('4befc438', component.options)
    }
    module.hot.accept("./PhoneDetailModal.vue?vue&type=template&id=4befc438&scoped=true", function () {
      api.rerender('4befc438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassMood/compoents/PhoneDetailModal.vue"
export default component.exports